<ng-scrollbar [style]="customStyle" visibility="hover" [dir]="direction" appearance="compact" orientation="vertical">
  <ng-content />
</ng-scrollbar>
